import { UserEntity } from "../entity/UserEntity";
import { Accounting } from "../gateway/Accounting/Accounting";
import { User } from "../gateway/User/User";
import { NormalizeString } from "../utils/normalize-string/NormalizeString";

export class PopulateUsersUsecase {
    constructor() {
        this.UserGateway = new User();
        this.AccountingGateway = new Accounting();
    }

    async execute({ accountingId = "", roles = [] } = {}) {
        const payload = this.sanitizeInput({
            accountingId,
            roles
        });
        if (!payload.accountingId || !payload.roles.length) return false;
        const response = await this.UserGateway.getUsersByRolesAndAccountingId({
            accountingId: payload.accountingId,
            roles: payload.roles
        });
        if (!response?.list?.length) return false;
        const users = this.restoreEntities(response.list);
        const accounting = await this.AccountingGateway.getById(
            payload.accountingId
        );
        const newList = users.map((u) => {
            const user = u.meteorModel;
            user.reference = accounting
                ? accounting.email == user.username
                : false;
            user.profile.name_nd = NormalizeString.normalizeUpperCaseNd(
                user.profile.name
            );
            user.group = this.transformRole(user.roles[0]);
            return user;
        });
        this.UserGateway.deleteMany({});
        this.UserGateway.createMany(newList);
        return true;
    }

    sanitizeInput({ accountingId = "", roles = [] } = {}) {
        const sanitizedAccountingId = String(accountingId).trim();
        const sanitizedRoles =
            Array.isArray(roles) && roles.length
                ? roles.filter((role) => Boolean(String(role).trim()))
                : [];
        return {
            accountingId: sanitizedAccountingId,
            roles: sanitizedRoles
        };
    }

    restoreEntities(users) {
        return users.map((user) => {
            return UserEntity.restoreFromCloud(user);
        });
    }

    transformRole(role) {
        const roles = {
            Contabilidade: "Administrador",
            Empresa: "Empresa",
            Contabil: "Contábil",
            Comercial: "Comercial",
            Fiscal: "Fiscal",
            Pessoal: "Pessoal",
            Financeiro: "Financeiro",
            Gestor: "Gestor",
            "Pessoal e Fiscal": "Pessoal e Fiscal",
            ContabilidadeTrial: "Trial",
            ContabilidadeTrialPro: "Trial"
        };
        return roles[role];
    }
}
